import { render, staticRenderFns } from "./SecurityBulletin.vue?vue&type=template&id=4ef589bc"
import script from "./SecurityBulletin.vue?vue&type=script&lang=js"
export * from "./SecurityBulletin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports